export class HandEvents
{
    static DRAG_SELECTED_CARDS_OVER_ANOTHER_CARD: string = 'HandEvents.DRAG_SELECTED_CARDS_OVER_ANOTHER_CARD';
    static DRAG_SELECTED_STACKS_OVER_CARD: string =  'HandEvents.DRAG_SELECTED_STACKS_OVER_CARD';
    static HIGHLIGHT: string = 'HandEvents.HIGHLIGHT';
    static UNHIGHLIGHT: string = 'HandEvents.UNHIGHLIGHT';
    static SORT_CARDS: string =  'HandEvents.SORT_CARDS';
    static UPDATED: string =  'HandEvents.UPDATED';
}
